import { IChatMessage, IRawErrorOut, IRawMessageEcho } from '../types';
import { ChatEventType } from '../types/enums/ProviderEventType';
import { ProviderEvent } from './ProviderEvents';

export class ChatMessageEvent extends ProviderEvent<IChatMessage> {
	constructor(data: IChatMessage) {
		super(ChatEventType.CHAT_MESSAGE, data);
	}
	get value(): IChatMessage {
		return this.data!;
	}
}
export class ChatEchoEvent extends ProviderEvent<IRawMessageEcho> {
	constructor(data: IRawMessageEcho) {
		super(ChatEventType.CHAT_ECHO, data);
	}
	get value(): IRawMessageEcho {
		return this.data!;
	}
}
export class ChatErrorEvent extends ProviderEvent<IRawErrorOut> {
	constructor(data: IRawErrorOut) {
		super(ChatEventType.CHAT_MESSAGE, data);
	}
	get value(): IRawErrorOut {
		return this.data!;
	}
}
